import { createRouter, createWebHistory } from 'vue-router'
import { useFormStore } from '@/stores/formStore'

const router = createRouter({
  history: createWebHistory((import.meta as any).env?.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/HomeView.vue')
    },
    {
      path: '/legal-entity',
      name: 'legal-entity',
      component: () => import('@/views/LegalEntityFormView.vue'),
      beforeEnter: (_to, _from, next) => {
        const formStore = useFormStore()
        formStore.setFormType('legal_entity')
        next()
      }
    },
    {
      path: '/physical-person',
      name: 'physical-person',
      component: () => import('@/views/PhysicalPersonFormView.vue'),
      beforeEnter: (_to, _from, next) => {
        const formStore = useFormStore()
        formStore.setFormType('physical_person')
        next()
      }
    },
    {
      path: '/success',
      name: 'success',
      component: () => import('@/views/SuccessView.vue')
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'NotFound',
      component: () => import('@/views/NotFoundView.vue')
    }
  ]
})

export default router
